<div class="background-form" *ngIf="clientInfo && !invalidToken">
    <div class="container-fluid">
        <div class="row">
            <div class="col-lg-3 p-0">
                <div class="client-info p-5">
                    <img src="assets/images/logo.png" alt="Diagnostic Learning Services Logo" width="150"
                        class="img-fluid mb-5">
                    <h4 class="text-grey">Appointment Information</h4>
                    <hr>
                    <div class="detail">
                        <ul>
                            <li>
                                <label>Name</label>
                                <p>{{clientInfo.clientName}}</p>
                            </li>
                            <li>
                                <label>Appointment Date/Time</label>
                                <p>{{clientInfo.appointmentDate}} (CST)</p>
                            </li>
                            <li>
                                <label>Location</label>
                                <p>{{clientInfo.Location}}</p>
                            </li>

                        </ul>
                    </div>
                </div>
            </div>
            <div class="col-lg-9 px-0">
                <div class="form bg-white p-4">
                    <h4 class="text-green">Assessment Information</h4>
                    <p class="alert alert-warning my-4">Please complete the following like <em>this is the first time
                            you have
                            shared this information with us.</em> This information WILL NOT bias the assessment but it
                        will ensure
                        that we address all of your concerns.</p>
                    <form [formGroup]="answersForm" class="custom-form">

                        <div id="questionsBank" class="input-outer rounded bg-purple-light py-3 mt-4">
                            <div class="col-12">
                                <div class="row">
                                    <div class="col-md-6">
                                        <label for="dateOfBirth">Date Of Birth *</label>
                                        <input type="test" formControlName="dateOfBirth" placeholder="Date of Birth"
                                            min="1950-01-01" max="3000-01-01"
                                            onfocus=" this.type='date',this.max=new Date().toISOString().split('T')[0]">
                                    </div>
                                    <div class="col-md-6">
                                        <label for="currentSchool">Place of Employment/School *</label>
                                        <input type="text" formControlName="currentSchool"
                                            placeholder="Place of Employment/School">
                                    </div>
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="row">
                                    <div class="col-md-6">
                                        <label for="question16">Primary area of Concern/Reason for assessment *</label>
                                        <select formControlName="answer16">
                                            <option value="" selected disabled>Select Option</option>
                                            <option value="Dyslexia">Dyslexia</option>
                                            <option value="Reading Comprehension">Reading Comprehension</option>
                                            <option value="Reading Fluency">Reading Fluency</option>
                                            <option value="Dysgraphia">Dysgraphia</option>
                                            <option value="Written Expression">Written Expression</option>
                                            <option value="Spelling">Spelling</option>
                                            <option value="Dyscalculia">Dyscalculia</option>
                                            <option value="Math Calculations">Math Calculations</option>
                                            <option value="Math Word Problems">Math Word Problems</option>
                                            <option value="Attention/Focus">Attention/Focus</option>
                                            <option value="Hyperactivity/Impulsivity">Hyperactivity/Impulsivity</option>
                                            <option value="ADHD">ADHD</option>
                                            <option value="Memory">Memory</option>
                                            <option value="Processing Skills">Processing Skills</option>
                                            <option value="Test Taking/Test Anxiety">Test Taking/Test Anxiety</option>
                                            <option value="Other">Other</option>
                                        </select>
                                    </div>
                                    <div class="col-md-6">
                                        <label for="question17">Additional area of Concern/Reason for assessment</label>
                                        <select formControlName="answer17">
                                            <option value="" selected disabled>Select Option</option>
                                            <option value="Dyslexia">Dyslexia</option>
                                            <option value="Reading Comprehension">Reading Comprehension</option>
                                            <option value="Reading Fluency">Reading Fluency</option>
                                            <option value="Dysgraphia">Dysgraphia</option>
                                            <option value="Written Expression">Written Expression</option>
                                            <option value="Spelling">Spelling</option>
                                            <option value="Dyscalculia">Dyscalculia</option>
                                            <option value="Math Calculations">Math Calculations</option>
                                            <option value="Math Word Problems">Math Word Problems</option>
                                            <option value="Attention/Focus">Attention/Focus</option>
                                            <option value="Hyperactivity/Impulsivity">Hyperactivity/Impulsivity</option>
                                            <option value="ADHD">ADHD</option>
                                            <option value="Memory">Memory</option>
                                            <option value="Processing Skills">Processing Skills</option>
                                            <option value="Test Taking/Test Anxiety">Test Taking/Test Anxiety</option>
                                            <option value="Other">Other</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12">
                                <label for="question1">Please elaborate on your choices above and tell us specifically
                                    what has led to your
                                    concerns. This can be your own observations as well as information from family
                                    members, professors,
                                    coworkers, or other professionals you have worked with. (Please be as specific as
                                    possible, this
                                    information will help us plan for your assessment) *</label>
                                <textarea formControlName="answer1" class="" id="" rows="3"></textarea>
                            </div>
                            <div class="col-12">
                                <label for="question2">How have these issues impacted your performance at school/work?
                                    *</label>
                                <textarea formControlName="answer2" rows="3"></textarea>
                            </div>
                            <div class="col-12">
                                <label for="question3">If you have ever been diagnosed with any type of learning
                                    disability, ADHD,
                                    speech/language impairment, or physical disability, please indicate the type of
                                    diagnosis you have
                                    received.</label>
                                <textarea formControlName="answer3" rows="3"></textarea>
                            </div>
                            <div class="col-12">
                                <label for="question4">Have you ever received support through any of the following
                                    programs? *</label>
                                <select formControlName="answer4">
                                    <option value="" selected disabled>Select Option</option>
                                    <option value="Section 504">Section 504</option>
                                    <option value="Special Education">Special Education</option>
                                    <option value="College Disability Support Program">College Disability Support
                                        Program</option>
                                    <option value="Private School Accommodations/Learning Lab">Private School
                                        Accommodations/Learning Lab</option>
                                    <option value="None">None</option>
                                </select>
                            </div>
                            <div class="col-12">
                                <label for="question5">If so, please tell us the type of support you received and what
                                    specific
                                    accommodations
                                    were provided for you.</label>
                                <textarea formControlName="answer5" rows="3"></textarea>
                            </div>
                            <div class="col-12">
                                <label for="question6">What do you hope to learn from this assessment? What do you plan
                                    to use this
                                    information
                                    for? *</label>
                                <textarea formControlName="answer6" rows="3"></textarea>
                            </div>
                            <div class="col-12">
                                <label for="question7">Do you have any medical conditions or are you currently taking
                                    any medications?
                                    *</label>
                                <textarea formControlName="answer7" rows="3"></textarea>
                            </div>
                            <div class="col-12">
                                <label for="question8">Do you have a family history of any Learning Disabilities, ADHD,
                                    Depression, or
                                    Anxiety?
                                    *</label>
                                <textarea formControlName="answer8" rows="3"></textarea>
                            </div>
                            <div class="col-12">
                                <label for="question9">How would you describe your performance when you were in
                                    elementary school? *</label>
                                <textarea formControlName="answer9" rows="3"></textarea>
                            </div>
                            <div class="col-12">
                                <label for="question10">What about Middle and High School? *</label>
                                <textarea formControlName="answer10" rows="3"></textarea>
                            </div>
                            <div class="col-12">
                                <label for="question11">If you are attending college, or attended in the past, describe
                                    your
                                    performance.</label>
                                <textarea formControlName="answer11" rows="3"></textarea>
                            </div>
                            <div class="col-12">
                                <label for="question12">Over the course of your school career, what subjects or classes
                                    were usually the
                                    easiest for
                                    you? *</label>
                                <textarea formControlName="answer12" rows="3"></textarea>
                            </div>
                            <div class="col-12">
                                <label for="question13">What subjects or classes did you find to be more challenging?
                                    *</label>
                                <textarea formControlName="answer13" rows="3"></textarea>
                            </div>
                        </div>

                        <div id="checkboxBank" class="checkbox-outer rounded bg-theme-light py-3 mt-4">
                            <div class="col-12">
                                <h5>Please indicate your level of concern for each of the following behaviors: *</h5>
                            </div>
                            <div class="col-12">
                                <div class="bg-white border rounded table-responsive mt-4">
                                    <table class="bg-white">
                                        <thead>
                                            <tr>
                                                <th>List of concerns</th>
                                                <th>No Concerns</th>
                                                <th>Mild Concerns</th>
                                                <th>Definite Concerns</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>Concentrate when reading</td>

                                                <td>
                                                    <div class="custom-control custom-radio">
                                                        <input type="radio" formControlName="concentrateWhenReading"
                                                            name="concentrateWhenReading" class="custom-control-input"
                                                            value="1">
                                                        <label class="custom-control-label"
                                                            for="concentrateWhenReading"></label>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="custom-control custom-radio">
                                                        <input type="radio" formControlName="concentrateWhenReading"
                                                            name="concentrateWhenReading" class="custom-control-input"
                                                            value="2">
                                                        <label class="custom-control-label"
                                                            for="concentrateWhenReading"></label>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="custom-control custom-radio">
                                                        <input type="radio" formControlName="concentrateWhenReading"
                                                            name="concentrateWhenReading" class="custom-control-input"
                                                            value="3">
                                                        <label class="custom-control-label"
                                                            for="concentrateWhenReading"></label>
                                                    </div>
                                                </td>
                                            </tr>


                                            <tr>
                                                <td>Avoid distractions</td>

                                                <td>
                                                    <div class="custom-control custom-radio">
                                                        <input type="radio" name="avoidDistractions"
                                                            formControlName="avoidDistractions"
                                                            class="custom-control-input" value="1">
                                                        <label class="custom-control-label"
                                                            for="avoidDistractions"></label>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="custom-control custom-radio">
                                                        <input type="radio" name="avoidDistractions"
                                                            formControlName="avoidDistractions"
                                                            class="custom-control-input" value="2">
                                                        <label class="custom-control-label"
                                                            for="avoidDistractions"></label>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="custom-control custom-radio">
                                                        <input type="radio" name="avoidDistractions"
                                                            formControlName="avoidDistractions"
                                                            class="custom-control-input" value="3">
                                                        <label class="custom-control-label"
                                                            for="avoidDistractions"></label>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Pay attention to a boring task</td>
                                                <td>
                                                    <div class="custom-control custom-radio">
                                                        <input type="radio" name="payAttentionInBoringClass"
                                                            formControlName="payAttentionInBoringClass"
                                                            class="custom-control-input" value="1">
                                                        <label class="custom-control-label"
                                                            for="Concentrate_when_reading"></label>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="custom-control custom-radio">
                                                        <input type="radio" name="payAttentionInBoringClass"
                                                            formControlName="payAttentionInBoringClass"
                                                            class="custom-control-input" value="2">
                                                        <label class="custom-control-label"
                                                            for="Concentrate_when_reading"></label>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="custom-control custom-radio">
                                                        <input type="radio" name="payAttentionInBoringClass"
                                                            formControlName="payAttentionInBoringClass"
                                                            class="custom-control-input" value="3">
                                                        <label class="custom-control-label"
                                                            for="Concentrate_when_reading"></label>
                                                    </div>
                                                </td>
                                            </tr>

                                            <tr>
                                                <td>Think before acting</td>
                                                <td>
                                                    <div class="custom-control custom-radio">
                                                        <input type="radio" name="thinkBeforeAct"
                                                            formControlName="thinkBeforeAct"
                                                            class="custom-control-input" value="1">
                                                        <label class="custom-control-label"
                                                            for="Concentrate_when_reading"></label>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="custom-control custom-radio">
                                                        <input type="radio" name="thinkBeforeAct"
                                                            formControlName="thinkBeforeAct"
                                                            class="custom-control-input" value="2">
                                                        <label class="custom-control-label"
                                                            for="Concentrate_when_reading"></label>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="custom-control custom-radio">
                                                        <input type="radio" name="thinkBeforeAct"
                                                            formControlName="thinkBeforeAct"
                                                            class="custom-control-input" value="3">
                                                        <label class="custom-control-label"
                                                            for="Concentrate_when_reading"></label>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Wait for your turn</td>
                                                <td>
                                                    <div class="custom-control custom-radio">
                                                        <input type="radio" name="waitForTurn"
                                                            formControlName="waitForTurn" class="custom-control-input"
                                                            value="1">
                                                        <label class="custom-control-label"
                                                            for="Concentrate_when_reading"></label>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="custom-control custom-radio">
                                                        <input type="radio" name="waitForTurn"
                                                            formControlName="waitForTurn" class="custom-control-input"
                                                            value="2">
                                                        <label class="custom-control-label"
                                                            for="Concentrate_when_reading"></label>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="custom-control custom-radio">
                                                        <input type="radio" name="waitForTurn"
                                                            formControlName="waitForTurn" class="custom-control-input"
                                                            value="3">
                                                        <label class="custom-control-label"
                                                            for="Concentrate_when_reading"></label>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Start something without being asked</td>
                                                <td>
                                                    <div class="custom-control custom-radio">
                                                        <input type="radio" name="startWithoutAsked"
                                                            formControlName="startWithoutAsked"
                                                            class="custom-control-input" value="1">
                                                        <label class="custom-control-label"
                                                            for="Concentrate_when_reading"></label>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="custom-control custom-radio">
                                                        <input type="radio" name="startWithoutAsked"
                                                            formControlName="startWithoutAsked"
                                                            class="custom-control-input" value="2">
                                                        <label class="custom-control-label"
                                                            for="Concentrate_when_reading"></label>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="custom-control custom-radio">
                                                        <input type="radio" name="startWithoutAsked"
                                                            formControlName="startWithoutAsked"
                                                            class="custom-control-input" value="3">
                                                        <label class="custom-control-label"
                                                            for="Concentrate_when_reading"></label>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Complete one task before starting a new one</td>
                                                <td>
                                                    <div class="custom-control custom-radio">
                                                        <input type="radio" name="completeTask"
                                                            formControlName="completeTask" class="custom-control-input"
                                                            value="1">
                                                        <label class="custom-control-label"
                                                            for="Concentrate_when_reading"></label>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="custom-control custom-radio">
                                                        <input type="radio" name="completeTask"
                                                            formControlName="completeTask" class="custom-control-input"
                                                            value="2">
                                                        <label class="custom-control-label"
                                                            for="Concentrate_when_reading"></label>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="custom-control custom-radio">
                                                        <input type="radio" name="completeTask"
                                                            formControlName="completeTask" class="custom-control-input"
                                                            value="3">
                                                        <label class="custom-control-label"
                                                            for="Concentrate_when_reading"></label>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Get and stay organised</td>
                                                <td>
                                                    <div class="custom-control custom-radio">
                                                        <input type="radio" name="stayOrganised"
                                                            formControlName="stayOrganised" class="custom-control-input"
                                                            value="1">
                                                        <label class="custom-control-label"
                                                            for="Concentrate_when_reading"></label>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="custom-control custom-radio">
                                                        <input type="radio" name="stayOrganised"
                                                            formControlName="stayOrganised" class="custom-control-input"
                                                            value="2">
                                                        <label class="custom-control-label"
                                                            for="Concentrate_when_reading"></label>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="custom-control custom-radio">
                                                        <input type="radio" name="stayOrganised"
                                                            formControlName="stayOrganised" class="custom-control-input"
                                                            value="3">
                                                        <label class="custom-control-label"
                                                            for="Concentrate_when_reading"></label>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Keep track of time</td>
                                                <td>
                                                    <div class="custom-control custom-radio">
                                                        <input type="radio" name="keepTrackOfTime"
                                                            formControlName="keepTrackOfTime"
                                                            class="custom-control-input" value="1">
                                                        <label class="custom-control-label"
                                                            for="Concentrate_when_reading"></label>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="custom-control custom-radio">
                                                        <input type="radio" name="keepTrackOfTime"
                                                            formControlName="keepTrackOfTime"
                                                            class="custom-control-input" value="2">
                                                        <label class="custom-control-label"
                                                            for="Concentrate_when_reading"></label>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="custom-control custom-radio">
                                                        <input type="radio" name="keepTrackOfTime"
                                                            formControlName="keepTrackOfTime"
                                                            class="custom-control-input" value="3">
                                                        <label class="custom-control-label"
                                                            for="Concentrate_when_reading"></label>
                                                    </div>
                                                </td>
                                            </tr>

                                            <tr>
                                                <td>Remember instructions with many steps</td>
                                                <td>
                                                    <div class="custom-control custom-radio">
                                                        <input type="radio" name="rememberInstructions"
                                                            formControlName="rememberInstructions"
                                                            class="custom-control-input" value="1">
                                                        <label class="custom-control-label"
                                                            for="Concentrate_when_reading"></label>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="custom-control custom-radio">
                                                        <input type="radio" name="rememberInstructions"
                                                            formControlName="rememberInstructions"
                                                            class="custom-control-input" value="2">
                                                        <label class="custom-control-label"
                                                            for="Concentrate_when_reading"></label>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="custom-control custom-radio">
                                                        <input type="radio" name="rememberInstructions"
                                                            formControlName="rememberInstructions"
                                                            class="custom-control-input" value="3">
                                                        <label class="custom-control-label"
                                                            for="Concentrate_when_reading"></label>
                                                    </div>
                                                </td>
                                            </tr>

                                            <tr>
                                                <td>Remember what you have read</td>
                                                <td>
                                                    <div class="custom-control custom-radio">
                                                        <input type="radio" name="rememberRead"
                                                            formControlName="rememberRead" class="custom-control-input"
                                                            value="1">
                                                        <label class="custom-control-label"
                                                            for="Concentrate_when_reading"></label>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="custom-control custom-radio">
                                                        <input type="radio" name="rememberRead"
                                                            formControlName="rememberRead" class="custom-control-input"
                                                            value="2">
                                                        <label class="custom-control-label"
                                                            for="Concentrate_when_reading"></label>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="custom-control custom-radio">
                                                        <input type="radio" name="rememberRead"
                                                            formControlName="rememberRead" class="custom-control-input"
                                                            value="3">
                                                        <label class="custom-control-label"
                                                            for="Concentrate_when_reading"></label>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Control emotions under stress</td>
                                                <td>
                                                    <div class="custom-control custom-radio">
                                                        <input type="radio" name="controlEmotions"
                                                            formControlName="controlEmotions"
                                                            class="custom-control-input" value="1">
                                                        <label class="custom-control-label"
                                                            for="Concentrate_when_reading"></label>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="custom-control custom-radio">
                                                        <input type="radio" name="controlEmotions"
                                                            formControlName="controlEmotions"
                                                            class="custom-control-input" value="2">
                                                        <label class="custom-control-label"
                                                            for="Concentrate_when_reading"></label>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="custom-control custom-radio">
                                                        <input type="radio" name="controlEmotions"
                                                            formControlName="controlEmotions"
                                                            class="custom-control-input" value="3">
                                                        <label class="custom-control-label"
                                                            for="Concentrate_when_reading"></label>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>

                        <div id="otherImformation" class="input-outer rounded bg-purple-light py-3 mt-4">
                            <div class="col-12">
                                <label for="question14">Please tell us what kinds of things you enjoy doing outside of
                                    school/work? *</label>
                                <textarea formControlName="answer14" class="" id="" rows="3"></textarea>
                            </div>
                            <div class="col-12">
                                <label for="question15">Is there any other information that you think will be helpful to
                                    the professionals that will be working with you?</label>
                                <textarea formControlName="answer15" class="" id="" rows="3"></textarea>
                            </div>
                            <div class="col-12">
                                <label for="backgroundFormComment">Referred By *</label>
                                <textarea formControlName="backgroundFormComment" rows="3"></textarea>
                            </div>
                            <div class="col-12 mt-4">
                                <div class="row">
                                    <div class="col-md-6">
                                        <label for="submitterName">Name of Individual submitting this information *</label>
                                        <input type="text" formControlName="submitterName" placeholder="Name" class="form-control">
                                    </div>
                                    <div class="col-md-6">
                                        <label>Date</label>
                                        <input type="text" [value]="currentDate | date:'MM/dd/yyyy'" readonly class="form-control bg-light">
                                    </div>
                                </div>
                            </div>
                        </div>



                        <p class="text-danger"><em>If you have copies of previous accommodation plans, 504 plans, IEPs
                                or a previous assessment report you would like to share, please email those directly to
                                laurie@diagnostic-learning.com</em></p>

                        <button class="theme-button mt-4 ml-md-auto" type="submit" data-toggle="modal"
                            data-target="#comfirmationModal" [ngClass]="{'disable-button' : answersForm.invalid}"
                            [disabled]="answersForm.invalid">Submit</button>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="comfirmationModal" data-backdrop="static" data-keyboard="false" tabindex="-1"
    aria-labelledby="comfirmationModal" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content light px-5 py-4">
            <h6 class="mb-4 text-center">Are you sure you want to submit the form?</h6>
            <div class="action text-center">
                <button type="submit" (click)="submit()" class="theme-button green mx-2" data-dismiss="modal">Yes,
                    Continue</button>
                <a href="#!" class="theme-button grey mx-2" data-dismiss="modal">No</a>
            </div>
        </div>
    </div>
</div>





<div *ngIf="invalidToken">
    <div class="container mt-5 pt-5">
        <div class="row justify-content-center">
            <div class="col-md-6">
                <div class="card p-5 text-center">
                    <h4 class="text-green">Form Submitted!</h4>
                    <p class="text-grey mb-4">Thank you, we look forward to your appointment.</p>
                    <a href="https://www.ltldpodcast.com/" class="theme-button grey mx-auto">Close</a>
                </div>
            </div>
        </div>
    </div>
</div>

<ngx-spinner bdColor="rgba(51, 51, 51, 0.8)" size="default" type="ball-scale-multiple"></ngx-spinner>